/**
 * Mini Cart Drawer
 * Opens a slide-out cart summary after add-to-cart (from PDP or quick-add),
 * or when the header cart icon is clicked — keeps shoppers in-flow instead
 * of bouncing to the full /cart page.
 */
(function () {
  const overlay = document.getElementById('miniCartOverlay');
  const drawer = document.getElementById('miniCartDrawer');
  const closeBtn = document.getElementById('miniCartClose');
  const content = document.getElementById('miniCartContent');
  const subtotalEl = document.getElementById('miniCartSubtotal');
  const cartBtn = document.getElementById('miniCartBtn');

  if (!overlay || !drawer || !content) return;

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function renderCart(cart) {
    if (!cart.items.length) {
      content.innerHTML = '<div class="mini-cart-empty">Your order is empty.</div>';
    } else {
      content.innerHTML = cart.items.map(function (item) {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        return (
          '<div class="mini-cart-item">' +
            '<img class="mini-cart-item-img" src="' + (item.image || '') + '" alt="' + item.product_title.replace(/"/g, '') + '" width="72" height="72" loading="lazy">' +
            '<div class="mini-cart-item-body">' +
              '<div class="mini-cart-item-title">' + item.product_title + '</div>' +
              (variant ? '<div class="mini-cart-item-variant">' + variant + '</div>' : '') +
              '<div class="mini-cart-item-qty">Qty ' + item.quantity + '</div>' +
            '</div>' +
            '<div class="mini-cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function openMiniCart() {
    if (window.unplatedCloseOverlays) window.unplatedCloseOverlays('minicart');
    overlay.classList.add('active');
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
    content.innerHTML = '<div class="mini-cart-loading">Loading&hellip;</div>';
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (err) {
      content.innerHTML = '<div class="mini-cart-empty">Couldn\'t load your cart. <a href="/cart">View cart</a></div>';
      console.error('[MiniCart]', err);
    }
  }

  function closeMiniCart() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  window.unplatedOpenMiniCart = openMiniCart;

  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openMiniCart();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeMiniCart);
  overlay.addEventListener('click', closeMiniCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeMiniCart();
  });
  document.addEventListener('unplated:closeOverlays', function (e) {
    if (e.detail.except !== 'minicart' && drawer.classList.contains('active')) closeMiniCart();
  });
})();
